export default "__VITE_ASSET__Yv0LzjfB__"